import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './shared/components/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { AuthGuard } from './shared/services/auth/auth.guard';

export const rootRouterConfig: Routes = [
  // {
  //   path: '',
  //   redirectTo: 'dashboard',
  //   pathMatch: 'full'
  // },
  {
    path: 'login',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: './views/sessions/sessions.module#SessionsModule',
        data: { title: 'Agent Dashboard Login' },
      },
    ],
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'mashboard',
        loadChildren: './views/main-layout/main-layout.module#MainLayoutModule',
        data: { title: '', breadcrumb: '' },
      },
      {
        path: 'dashboard',
        loadChildren: './views/others/others.module#OthersModule',
        data: { title: 'Others', breadcrumb: 'OTHERS' },
      },
      {
        path: 'lead',
        loadChildren: './views/profile/profile.module#ProfileModule',
        data: { title: '', breadcrumb: 'Lead', breadcrumbHide: true },
      },
      {
        path: 'inbox',
        loadChildren: './views/app-inbox/app-inbox.module#AppInboxModule',
        data: { title: 'Inbox', breadcrumb: 'INBOX' },
      },
      {
        path: 'calendar',
        loadChildren:
          './views/app-calendar/app-calendar.module#AppCalendarModule',
        data: { title: 'Calendar', breadcrumb: 'CALENDAR' },
      },
      // {
      //   path: 'chat',
      //   loadChildren: './views/app-chats/app-chats.module#AppChatsModule',
      //   data: { title: 'Chat', breadcrumb: 'Chat'}
      // },
      {
        path: 'contacts',
        loadChildren: './views/contacts/contacts.module#ContactsModule',
        data: { title: 'Leads', breadcrumb: 'Leads' },
      },
      {
        path: 'properties',
        loadChildren: './views/properties/properties.module#PropertiesModule',
        data: { title: 'Properties', breadcrumb: 'Properties' },
      },
      {
        path: 'tables',
        loadChildren: './views/tables/tables.module#TablesModule',
        data: { title: 'Tables', breadcrumb: 'TABLES' },
      },
      {
        path: 'dragndrop',
        loadChildren: './views/dragndrop/dragndrop.module#DragndropModule',
        data: { title: 'Drag and Drop', breadcrumb: 'DND' },
      },
      {
        path: 'property-finder',
        loadChildren:
          './views/property-finder/property-finder.module#FinderModule',
        data: { title: 'Property Finder' },
      },
      {
        path: 'settings',
        loadChildren: './views/forms/forms.module#AppFormsModule',
        data: { title: 'Settings', breadcrumb: 'Settings' },
      },
      {
        path: 'mail',
        loadChildren:
          './views/mail-settings/mail-settings.module#MailSettingsModule',
        data: { title: 'Mail Settings', breadcrumb: 'Mail Settings' },
      },
      {
        path: 'import-contacts',
        loadChildren:
          './views/contacts-import/contacts-import.module#ContactsImportModule',
        data: { title: 'Import Contacts', breadcrumb: 'Import Contacts' },
      },
      {
        path: 'property-marketplace',
        loadChildren: './views/off-market/off-market.module#OffMarketModule',
        data: {
          title: 'Property Marketplace',
          breadcrumb: 'Property Marketplace',
        },
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'sessions/404',
  },
];
